// import { Injectable } from '@angular/core';

// @Injectable({
//   providedIn: 'root'
// })
// export class ShoppingSessionService {

//   constructor() { }
// }
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ShoppingSessionService {
  private localStorageKey = 'ShoppingSession';

  constructor() { }

  getSharedData(): any {
    const dataString = localStorage.getItem(this.localStorageKey);
    return dataString ? JSON.parse(dataString) : {};
  }

  setSharedData(data: any) {
    localStorage.setItem(this.localStorageKey, JSON.stringify(data));
  }

  getValue(key: string): any {
    const data = this.getSharedData();
    return data[key];
  }

  setValue(key: string, value: any) {
    const data = this.getSharedData();
    data[key] = value;
    this.setSharedData(data);
  }

  clearSharedData() {
    localStorage.removeItem(this.localStorageKey);
  }
}

/*

// Retrieve shared data when the component initializes
    this.sharedData = this.sharedDataService.getSharedData();

    // Update the shared data
    updateSharedData() {    
    const newData = {
      key1: 'value1',
      key2: 'value2',
      // Add more key-value pairs as needed
    };
    this.sharedDataService.setSharedData(newData);
  }

  //set single value
  this.sharedDataService.setValue('isFirsttime', true);

  //get single value 
  const isFirsttimeDDD = this.sharedDataService.getValue('isFirsttime');
*/